import JSZip from "jszip";
import { saveAs } from "file-saver";

const Compress = (files, zipname, facturaZip) => {
    if ( facturaZip === true ) {
      files.forEach((file) => {
        const blob = new Blob([file.contenido], { type: "application/octet-stream" });
        saveAs(blob, file.nombre);
      });
    } else if (facturaZip === null || facturaZip === undefined || facturaZip === false) {
      const zip = new JSZip();
      const folder = zip.folder(zipname);
    
      files.forEach((file) => {
        folder.file(file.nombre, file.contenido); 
      });
  
      zip.generateAsync({ type: "blob" })
        .then((content) => {
          saveAs(content, `${zipname}.zip`);
        })
        .catch((error) => {
          console.error("Error al generar el ZIP:", error);
        });
    }
};

export default Compress;